<template>
  <div class="container">
    <div class="content">
      <!-- {{ form }} -->
      <div class="forms">
        <el-form :inline="true" :model="form" ref="form" class="search-form-2" size="small" label-width="84px">
          <el-form-item label="日期筛选">
            <eldate @changeData="changeData" :dateData="createTime" :max-range-days="31"></eldate>
          </el-form-item>
          <el-form-item label="员工姓名">
            <el-autocomplete v-model="form.reallyName" :fetch-suggestions="searchUser" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect" class="width-204"
              clearable></el-autocomplete>
          </el-form-item>
          <el-form-item label="所属部门">
            <el-cascader @change="handleSelectOrgId" v-model="form.orgId1" :options="options" :show-all-levels="false" class="width-204" :props="{
              checkStrictly: true,
              label: 'orgName',
              value: 'orgPath',
              children: 'children',
            }" clearable filterable></el-cascader>
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <div class="s-btn" @click="fetchData('search')">查询</div>
              <div class="r-btn" @click="fetchData('reset')">重置</div>
            </div>
          </el-form-item>
          <el-form-item style="float: right;margin-right: 0;">
            <el-button size="mini" @click="onDownLoad" icon="el-icon-download" v-if="parArray.includes('export_stat')" :loading="exportLoading" >导出报表</el-button>
          </el-form-item>
        </el-form>
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.pageTotal" layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50, 200, 2000]" :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange" v-loading="loading">
        </lb-table>
      </div>
    </div>
    <!-- 考勤明细 -->
     <pop-stat-detail ref="popStatDetail"></pop-stat-detail>
  </div>
</template>
<script>
import eldate from "@/components/eldate.vue";
import LbTable from "@/components/lb-table/lb-table";
import { formatDateTime, getWeekDay } from "@/utils/index.js";
import popStatDetail from "@/pages/assetManagement/common/popStatDetail.vue";
const getClockResult = (key)=>{
  let obj = {
    'NORMAL':'正常',
    'LATE':'迟到',
    'LEAVE':'请假',
    'OUTSIDE':'外勤',
    'REPAIR':'补卡',
    'MISSING':'缺卡', // 统一缺卡状态（兼容新版接口）
    'MISSING_IN':'缺卡', // 上班缺卡
    'MISSING_OUT':'缺卡', // 下班缺卡
    'EARLY':'早退',
    'NOT_PUNCHED':'未打卡',
    'ABSENCE':'旷工',
    'LATE_UPGRADE':'旷工',// 迟到升级旷工
    'EARLY_UPGRADE':'旷工', // 早退升级旷工
  }
  return obj[key]
}
export default {
  name: "attendanceManagementShiftList",
  components: { eldate, LbTable,popStatDetail },
  data() {
    return {
      form: {
        reallyName: '',
        orgId1: [],
      },
      createTime: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      options: [], //部门选择列表

      list: [
        {
          id: 1,
          department: '网络运维部',
          employee: 'B-I-007',
          name: '张三',
          rowValue: ['班次01班次01班次01班次01班次01', '班次02', '节假日', '无']
        },
        {
          id: 2,
          department: 'IT技术部',
          employee: 'B-I-008',
          name: '李四',
          rowValue: ['节假日', '无', '班次01', '班次02',]
        }
      ],
      loading: false,
      exportLoading:false,
      totalNum: 0,
      parArray: [],
      columns: [
        {
          label: '部门', prop: 'orgName', width: '120', fixed: 'left',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.orgName}</div>
            )
          }
        },
        {
          label: '工号', prop: 'employeeNo', width: '120', fixed: 'left',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.employeeNo}</div>
            )
          }
        },
        {
          label: '姓名', prop: 'employeeName', minWidth: '120', fixed: 'left',
          render: (h, scope) => {
            let seeDetail = this.parArray.includes('detail_stat') && scope.row.isPastDay
            let text
            let name = scope.row.employeeName
            let resigned
            if (scope.row.resigned) {
              resigned ='(已离职)'
            }
            if (seeDetail) {
              text = <div class='align-left' style="color:#00B498;cursor:pointer; line-height:1.1" onClick={() => { this.onDetail(scope.row) }} >{name}<br/>{resigned}</div>
            } else {
              text = <div class='align-left' style="line-height:1.1" >{name}<br/>{resigned}</div>
            }
            return (
              text
            )
          }
        },
        {
          label: '考勤组', prop: 'groupName', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            let groupName = scope.row.groupName
            let text
            if (groupName) {
              text = <div class='align-left ellipsis2' title={groupName}>{groupName}</div>
            }else{
              text = <div class='align-left' style="color:#9999;" >未加入考勤组</div>
            }
            return (text)
          }
        },
        {
          label: '日期', prop: 'date', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div class='day-week'>
                <div class='day'>{scope.row.date}</div>
                <div class='week'>{scope.row.week}</div>
              </div>
            )
          }
        },
        {
          label: '班次', prop: 'shiftDisplayText', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.shiftDisplayText || '无'}</div>
            )
          }
        },
        {
          label: '上班1打卡时间', prop: 'actualInTime', minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                上班1打卡<br />时间
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.actualInTime}</div>
            )
          }
        },
        {
          label: '上班1打卡结果', prop: 'clockInResult', minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                上班1打卡<br />结果
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.clockInResult}</div>
            )
          }
        },
        {
          label: '下班1打卡时间', prop: 'actualOutTime', minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                下班1打卡<br />时间
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.actualOutTime}</div>
            )
          }
        },
        {
          label: '下班1打卡结果', prop: 'clockOutResult', minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                下班1打卡<br />结果
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.clockOutResult}</div>
            )
          }
        },
        {
          label: '关联的审批单', prop: 'approvalInfo', width: '230', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div class='align-left'>
                  {scope.row.approvalDisplayText && scope.row.approvalDisplayText.split('；').map((item, index) => (
                      <div key={index}>{item}；</div>
                  ))}
              </div>
            )
          }
        },
        {
          label: '出勤天数', prop: 'attendanceDays', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.attendanceDays}</div>
            )
          }
        },
        {
          label: '休息天数', prop: 'restDays', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.restDays}</div>
            )
          }
        },
        {
          label: '工作时长(分)', prop: 'workMinutes', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                工作时长<br />（分）
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.workMinutes}</div>
            )
          }
        },
        {
          label: '迟到次数', prop: 'lateCount', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.lateCount}</div>
            )
          }
        },
        {
          label: '迟到时长(分)', prop: 'lateMinutes', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                迟到时长<br />（分）
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.lateMinutes}</div>
            )
          }
        },
        {
          label: '迟到升级旷工次数', prop: 'lateUpgradeCount', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                迟到升级旷工<br />次数
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.lateUpgradeCount}</div>
            )
          }
        },
        {
          label: '早退次数', prop: 'earlyCount', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.earlyCount}</div>
            )
          }
        },
        {
          label: '早退时长(分)', prop: 'earlyMinutes', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                早退时长<br />(分)
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.earlyMinutes}</div>
            )
          }
        },
        {
          label: '早退升级旷工次数', prop: 'earlyUpgradeCount', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                早退升级旷工<br />次数
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.earlyUpgradeCount}</div>
            )
          }
        },
        {
          label: '上班缺卡次数', prop: 'missingInCount', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                上班缺卡<br />次数
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.missingInCount}</div>
            )
          }
        },
        {
          label: '下班缺卡次数', prop: 'missingOutCount', minWidth: '120', headerAlign: 'center',
          renderHeader: (h, scope) => {
            return (
              <div class='header-con'>
                下班缺卡<br />次数
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>{scope.row.missingOutCount}</div>
            )
          }
        },
        {
          label: '旷工天数', prop: 'absenceDays', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.absenceDays}</div>
            )
          }
        },
        {
          label: '补卡次数', prop: 'repairCount', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.repairCount}</div>
            )
          }
        },
        {
          label: '请假次数', prop: 'leave', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.leaveCount != null ? scope.row.leaveCount : (scope.row.leave ? 1 : 0)}</div>
            )
          }
        },
        {
          label: '外勤天数', prop: 'outside', minWidth: '120', headerAlign: 'center',
          render: (h, scope) => {
            return (
              <div>{scope.row.outsideDays != null ? scope.row.outsideDays : (scope.row.outside ? 1 : 0)}</div>
            )
          }
        },
      ]
    }
  },
  activated() {
    this.initTwoDay()
    this.fetchData()

  },
  created() {
    this.department()

    // 权限设定判断 
    const limits = JSON.parse(sessionStorage.getItem("limit"))
    const params = limits.buttonTreeDto.find(
      (item) => item.menuCode === "attendanceManagementStat"
    )
    params && params.buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })


  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} 00:00:00`
    },
    handleSelect(item) {
      this.form.reallyName = item.name
    },
    handleSelectOrgId(e) {
      this.form.orgId = e
    },
    searchUser(queryString, cb) {
      this.$api.userSearch(this.form.reallyName).then((res) => {
        console.log(res)
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.value = item.name
          })
          this.staffs = res.data
          var staffs = this.staffs;
          var results = queryString ? staffs : [];
          // 调用 callback 返回建议列表的数据
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
          // cb(results);
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 部门选择列表
    department() {
      this.axios
        .post(
          "/sys/v1/org/tree/select",
          {
            request: {
              orgName: "",
              orgType: "",
            },
            version: "",
          },
          {
            headers: {
              isLoading: false,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.options = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    changeData(val, e) {
      this.createTime = val
    },
    fetchData(type) {
      this.loading = true
      if (type == 'reset') {
        this.form = {
          name: '',
        }
        this.page = {
          pageNo: 1,
          pageSize: 10,
          pageTotal: 0,
        }
        this.initTwoDay()
      }
      if (type == 'search') {
        this.page.pageNo = 1
      }
      this.postData = {
        startDate: formatDateTime(this.createTime[0], 'yyyy-mm-dd'),
        endDate: formatDateTime(this.createTime[1], 'yyyy-mm-dd'),
        employeeName: this.form.reallyName,
        orgCode:'',
        pageSize: this.page.pageSize,
        pageNo: this.page.pageNo
      };
      if (this.form.orgId1) {
        let last = this.form.orgId1.length - 1
        this.postData.orgCode = this.form.orgId1[last]
      }
      console.log('>>', this.postData, this.form)
      // return false
      this.loading = true
      this.$api.statList(this.postData).then(res => {
        if (res.code == 0) {
          const data = res.data || {}
          let list = data.records || []
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          list.length > 0 && list.forEach(item => {
            item.week = item.date && getWeekDay(item.date, 'zh')
            // item.approvalInfo = this.setApprovalInfo(item.approvalSummaries)
            const itemDate = new Date(item.date)
            itemDate.setHours(0, 0, 0, 0)
            item.isPastDay = (itemDate <= today) // 是否过去日期
            // 实际上下班打卡时间
            let actualInTime = item.segments && item.segments[0].actualInTime
            item.actualInTime = formatDateTime(actualInTime, 'HH:MM')
            let actualOutTime = item.segments && item.segments[0].actualOutTime
            item.actualOutTime = formatDateTime(actualOutTime, 'HH:MM')
            // 打卡结果
            item.clockInResult = getClockResult(item.segments && item.segments[0].clockInResult) 
            item.clockOutResult = getClockResult(item.segments && item.segments[0].clockOutResult) 
          })
          this.list = list
          this.page.pageTotal = data.total
        } else {
          this.$message.error(res.message)
        }
        console.log('list：',this.list)
      }).finally(() => {
        this.loading = false
      })
    },

    handleSizeChange(e) {
      this.page.pageSize = e
      this.fetchData()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e
      this.fetchData()
    },
    onMultipleSelection(val) {
      // if (val.length == this.page.pageSize) {
      //     this.form.allFlag = 1
      // }
      if (val) {
        this.form.ids = val.map((item) => {
          return item.id
        })
      }

    },
    onDetail(item) {
      console.log('>>', item)
      let userData = {
        id:item.employeeId,
        day:item.date
      }
      this.$api.statUserDetail(userData).then(res=>{
        if (res.code==0) {
          this.$refs.popStatDetail.show(res.data)
        }
      })
    },
    onDownLoad() {
      this.exportLoading = true
      this.$api.statExport(this.postData).then(res => {
        if (res.code == 0) {
          let data = res.data || {}
          this.downloadlink(data.fileUrl)
        }
      }).finally(() => {
        this.exportLoading = false
      })
    },
    // 处理审批信息
    // setApprovalInfo(list) {
    //   let res = ''
    //   if (Array.isArray(list) && list.length > 0) {
    //     list.forEach(item => {
    //       if (item.type === 'LEAVE') {
    //         // 请假类型
    //         res += `${item.leaveType}${this.initDayValue(item.startTime,item.endTime)}；\n`
    //       } else if (item.type === 'OUTSIDE') {
    //         res += `外勤${this.initDayValue(item.startTime,item.endTime)}；\n`
    //       } else if (item.type === 'REPAIR') {
    //         res += `补卡${formatDateTime(item.repairTime, 'mm-dd')}；\n`
    //       }
    //     })
    //   }
    //   return res
    // },
    // 计算天数
    // initDayValue(startTime,endTime) {
    //   let dayNum = calculateDays(startTime,endTime)
    //   if(dayNum == 1){
    //     return `${formatDateTime(startTime, 'mm-dd')} 1天`
    //   }else{
    //     return `${formatDateTime(startTime, 'mm-dd')}到${formatDateTime(endTime, 'mm-dd')} ${dayNum}天`
    //   }
    // },
    // 设置默认日期为最近两天
    initTwoDay(){
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(today.getDate() - 1)
      this.createTime = [this.formatDate(yesterday), this.formatDate(today)]
    }

  }

}
</script>
<style lang="scss">
.header-con {
  // font-size: 13px;
  line-height: 1.1;
  text-align: center;
}

.day-week {
  line-height: 1;
  text-align: center;

  .day {
    display: inline-block;
    font-size: 13px;
    margin-bottom: 4px;
  }

  .week {
    display: inline-block;
    font-size: 13px;
  }
}
</style>
<style lang="scss" src="@/pages/attendanceManagement/common/style/common.scss" scoped />
